import { render } from "./consulting.vue?vue&type=template&id=4e91730a&scoped=true"
const script = {}

import "./consulting.vue?vue&type=style&index=0&id=4e91730a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e91730a"]])

export default __exports__